module.exports = __webpack_public_path__ + "img/pethouse14.36ee8d33.jpg";